import RouteProgressComponent from './route_progress.component'

let routeProgressModule = angular.module('routeProgress', [])

    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/routeProgress');

        $stateProvider
            .state('routeProgress', {
                url: '/route-progress',
                component: 'routeProgress',
                data: {
                    requireLogin: true,
                    requireACL: 'route_progress.all'
                },
                parent: 'app',
            })

    })
    .component('routeProgress', RouteProgressComponent)

    .name;

export default routeProgressModule;


// WEBPACK FOOTER //
// ./client/app/components/route_progress/index.js